<script>
import AppointmentRequest from './appointment-request.vue'
import MeetingStatusBadge from './meeting-status-badge.vue'

export default {
  name: 'MeetingToolbar',
  components: { AppointmentRequest, MeetingStatusBadge },
  props: {
    icsUid:      { type: String, required: true },
    status:      { type: String, required: true },
    isOtherUser: { type: Boolean, default: true },
    attachments: { type: Array, default: () => [] },
    showActions: { type: Boolean, default: true },
  },
  data() {
    return {
      showCancelForm: false,
      showRescheduleForm: false,
      cancelReason: '',
    }
  },
  methods: {
    accept()  { this.patchStatus('accepted') },
    decline() { this.patchStatus('declined') },

    patchStatus(newStatus) {
      this.$api.patch(`/meetings/${this.icsUid}/`, { status: newStatus }).then(() => {
        this.$emit('status-changed', { status: newStatus, icsUid: this.icsUid })
      })
    },

    toggleCancel() {
      this.showRescheduleForm = false
      this.cancelReason = ''
      this.showCancelForm = !this.showCancelForm
    },
    confirmCancel() {
      this.$api.patch(`/meetings/${this.icsUid}/`, {
        status: 'canceled', message: this.cancelReason,
      }).then(() => {
        this.showCancelForm = false
        this.cancelReason = ''
        this.$emit('status-changed', { status: 'canceled', icsUid: this.icsUid })
      })
    },

    toggleReschedule() {
      this.showCancelForm = false
      this.showRescheduleForm = !this.showRescheduleForm
    },
    getEndTime(startTime, mins) {
      let d = new Date()
      const [hh, mm] = startTime.split(':').map(Number)
      d.setUTCHours(hh, mm + mins, 0, 0)
      return d.toISOString().slice(11, 16)
    },
    onReschedule(info) {
      this.showRescheduleForm = false
      let endTime = this.getEndTime(info.time, info.duration)
      this.$api.post(`/meetings/${this.icsUid}/reschedule/`, {
        startTime: info.date + 'T' + info.time + ':00',
        endTime: info.date + 'T' + endTime + ':00',
        subject: info.subject,
        message: info.message || '',
      }).then((response) => {
        this.$emit('rescheduled', { icsUid: this.icsUid, response: response.data })
      })
    },

    downloadIcs() {
      let icsAtt = this.attachments.find(a => a.mime_type === 'text/calendar')
      if (icsAtt) {
        let link = document.createElement('a')
        link.href = icsAtt.file
        link.download = icsAtt.filename || 'meeting.ics'
        link.click()
        return
      }
      this.$api.get(`/meetings/${this.icsUid}/`, { params: { ics: 1 } }).then(response => {
        let blob = new Blob([response.data.trim()], { type: 'text/calendar' })
        let link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = 'appointment.ics'
        link.click()
      })
    },
  }
}
</script>

<template>
<div>
  <div class="d-flex align-items-center">
    <meeting-status-badge :status="status" />

    <div v-if="showActions" class="ms-auto">
      <template v-if="status === 'pending' && isOtherUser">
        <button class="btn btn-sm btn-success me-1" @click="accept" title="Annehmen">
          <i class="fas fa-check"></i>
        </button>
        <button class="btn btn-sm btn-outline-danger me-1" @click="decline" title="Ablehnen">
          <i class="fas fa-times"></i>
        </button>
      </template>

      <button v-if="status === 'accepted'" class="btn btn-sm btn-outline-primary me-1"
        @click="downloadIcs" title="ICS herunterladen">
        <i class="fas fa-download"></i> ICS
      </button>

      <button v-if="status !== 'canceled'" class="btn btn-sm btn-outline-warning me-1" @click="toggleReschedule" title="Verschieben">
        <i class="fas fa-clock"></i>
      </button>
      <button v-if="status !== 'canceled' && status !== 'pending'" class="btn btn-sm btn-outline-danger" @click="toggleCancel" title="Stornieren">
        <i class="fas fa-ban"></i>
      </button>
    </div>
  </div>

  <div v-if="showCancelForm" class="mt-2">
    <div class="input-group input-group-sm">
      <input type="text" class="form-control" v-model="cancelReason" placeholder="Grund (optional)">
      <button class="btn btn-danger" @click="confirmCancel">Stornieren</button>
      <button class="btn btn-outline-secondary" @click="showCancelForm = false">Abbrechen</button>
    </div>
  </div>

  <appointment-request v-if="showRescheduleForm" :show-message="true"
    @submit="onReschedule($event)" @cancel="showRescheduleForm = false" class="mt-2" />
</div>
</template>
